<template>
  <div>
    <!-- Summary Cards -->
    <div class="row no-gutters mb-3">
      <div class="col-md-4 pr-md-2 mb-2 mb-md-0">
        <div class="summary-card border rounded px-3 py-3 d-flex align-items-center">
          <div class="summary-icon mr-3" style="background:#C6F8E8;border-radius:12px;width:48px;height:48px;display:flex;align-items:center;justify-content:center;">
            <span v-html="fileIcon" />
          </div>
          <div>
            <div class="font-weight-bold">IDR. {{ formatCurrency(totalBilling) }}</div>
            <div class="text-muted small">Total Billing</div>
          </div>
        </div>
      </div>
      <div class="col-md-4 px-md-1 mb-2 mb-md-0">
        <div class="summary-card border rounded px-3 py-3 d-flex align-items-center">
          <div class="summary-icon mr-3" style="background:#D9E1FF;border-radius:12px;width:48px;height:48px;display:flex;align-items:center;justify-content:center;">
            <span v-html="fileIcon" />
          </div>
          <div>
            <div class="font-weight-bold">IDR. {{ formatCurrency(totalUnpaid) }}</div>
            <div class="text-muted small">Total Unpaid</div>
          </div>
        </div>
      </div>
      <div class="col-md-4 pl-md-2">
        <div class="summary-card border rounded px-3 py-3 d-flex align-items-center">
          <div class="summary-icon mr-3" style="background:#F6D5D5;border-radius:12px;width:48px;height:48px;display:flex;align-items:center;justify-content:center;">
            <span v-html="fileIcon" />
          </div>
          <div>
            <div class="font-weight-bold">IDR. {{ formatCurrency(totalPaid) }}</div>
            <div class="text-muted small">Total Paid</div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-2">
      <div class="d-flex">
        <b-form-input v-model="search" placeholder="Search" class="mr-2" @input="fetchPaymentLists" />
        <date-picker v-model="period" range format="DD/MM/YYYY" @change="fetchPaymentLists" />
        <b-form-select v-model="status" :options="statusOptions" class="ml-2" @change="fetchPaymentLists" />
      </div>
      <b-button size="sm" variant="primary" @click="openAdd">+ Add Data Payment List</b-button>
    </div>
    <!-- <b-table :items="filtered" :fields="fields" small responsive selectable select-mode="multi" @row-selected="onSelect">
      <template #cell(invoiceFile)="{ item }">
        <b-button size="sm" variant="outline-secondary" @click="$emit('download', item)">Download</b-button>
      </template>
      <template #cell(status)="{ item }">
        <b-badge :variant="item.status === 'Approved' ? 'success' : item.status === 'Requested' ? 'warning' : 'secondary'">{{ item.status }}</b-badge>
      </template>
      <template #cell(action)="{ index }">
        <b-dropdown right size="sm" text="Action" variant="outline-primary">
          <b-dropdown-item @click="edit(index)">Edit</b-dropdown-item>
          <b-dropdown-item class="text-danger" @click="remove(index)">Delete</b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table> -->

    <div class="d-flex overflow-auto">
      <table class="table">
        <thead class="thead-light">
          <tr>
            <th class="text-truncate">Detail Shipment ID</th>
            <th class="text-truncate">Real Invoice Number</th>
            <th class="text-truncate">Invoice Date</th>
            <th class="text-truncate">Due Date</th>
            <th class="text-truncate">Invoice File</th>
            <th class="text-truncate">Status</th>
            <th class="text-truncate">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in value" :key="index">
            <td class="text-truncate">
              <div v-if="item.shippment_plan">
                <div v-for="(plan, pIdx) in JSON.parse(item.shippment_plan)" :key="pIdx">
                  {{ plan.shipment_plan_detail_number }}
                </div>
              </div>
            </td>
            <td class="text-truncate">-</td>
            <td class="text-truncate">{{ item.request_date_start ? moment(item.request_date_start).format('DD MMM YYYY') : '-' }}</td>
            <td class="text-truncate">{{ item.request_date_end ? moment(item.request_date_end).format('DD MMM YYYY') : '-' }}</td>
            <td class="text-truncate">
              <!-- <b-button size="sm" variant="outline-secondary" @click="$emit('download', item)">Download</b-button> -->
              -
            </td>
            <td class="text-truncate">
              <b-badge :variant="item.status === 'Approved' ? 'success' : item.status === 'Requested' ? 'warning' : 'secondary'">{{ item.status || 'Requested' }}</b-badge>
            </td>
            <td class="text-truncate">
              <b-button 
                :id="`action-popover-payment-list-${index}`"
                size="sm" 
                variant="outline-primary"
                tabindex="0"
              >
                Action
              </b-button>
              <b-popover 
                :target="`action-popover-payment-list-${index}`" 
                triggers="focus" 
                placement="left"
                custom-class="action-popover"
              >
                <div class="d-flex flex-column">
                  <b-button 
                    variant="link" 
                    size="sm" 
                    class="text-left p-1" 
                    @click="edit(index)"
                  >
                    Edit
                  </b-button>
                  <b-button 
                    variant="link" 
                    size="sm" 
                    class="text-left p-1 text-danger" 
                    @click="remove(index)"
                  >
                    Delete
                  </b-button>
                </div>
              </b-popover>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Sidebar: SlidePaymentList -->
     <CustomSidebar
      v-model="showSidebar"
      title="Add Payment List"
      size="100%"
      noCloseOnBackdrop
      noCloseOnEsc
    >
      <SlidePaymentList
        v-if="showSidebar"
        :action="sidebarAction"
        :projectId="projectId"
        :paymentId="sidebarPaymentId"
        :projectData="projectData"
        :optionsProjectTerms="optionsProjectTerms"
        :positionListTextPOD="positionListTextPOD"
        :positionListTextPOL="positionListTextPOL"
        :optionsFleetTypes="fleetTypeOptions"
        :optionsCargoType="optionsCargoType"
        :fleetOptions="fleetOptions"
        :refreshData="refreshData"
        @close="closeSidebar"
        @saved="onSidebarSaved"
      />
    </CustomSidebar>
  </div>
</template>
<script>
import SlidePaymentList from '../../Dashboard/SlidePaymentList.vue'
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import hmacClient from '@/src/services/hmacClient'

export default {
  name: 'PaymentListTable',
  props: {
    value: { type: Array, default: () => [] },
    // optional context used by SlidePaymentList
    projectId: { type: [Number, String], default: null },
    projectData: { type: Object, default: null },
    optionsProjectTerms: {
      type: Array,
      required: true,
      default: () => [],
    },
    positionListTextPOD: {
      type: Array,
      default: () => [],
    },
    positionListTextPOL: {
      type: Array,
      default: () => [],
    },
    optionsFleetTypes: {
      type: Array,
      default: () => [],
      required: true,
    },
    fleetOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    optionsCargoType: {
      type: Array,
      required: true,
      default: () => [],
    },
    refreshData: {
      type: Function,
      default: true,
    },
  },
  data() {
    return {
      selected: [],
      showSidebar: false,
      sidebarAction: 'ADD',
      sidebarPaymentId: null,
      editIndex: null,
      search: '',
      period: [],
      status: 'Request',
      statusOptions: ['Request', 'Approved', 'Paid'],
      fields: [
        { key: 'selected', label: '', selectable: true },
        { key: 'detailShipmentId', label: 'Detail Shipment ID' },
        { key: 'realInvoiceNumber', label: 'Real Invoice Number' },
        { key: 'invoiceDate', label: 'Invoice Date' },
        { key: 'dueDate', label: 'Due Date' },
        { key: 'invoiceFile', label: 'Invoice File' },
        { key: 'status', label: 'Status' },
        { key: 'action', label: 'Action' },
      ],
      form: {
        detailShipmentId: '',
        realInvoiceNumber: '',
        invoiceDate: null,
        dueDate: null,
        invoiceFile: null,
        status: 'Request',
      },
      fileIcon: `<svg width="18" height="25" viewBox="0 0 18 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.6719 5.12695L13.0828 0.341797C12.8719 0.12207 12.5859 0 12.2859 0H12V6.25H18V5.95215C18 5.64453 17.8828 5.34668 17.6719 5.12695ZM10.5 6.64062V0H1.125C0.501562 0 0 0.522461 0 1.17188V23.8281C0 24.4775 0.501562 25 1.125 25H16.875C17.4984 25 18 24.4775 18 23.8281V7.8125H11.625C11.0063 7.8125 10.5 7.28516 10.5 6.64062ZM3 3.51562C3 3.2998 3.16781 3.125 3.375 3.125H7.125C7.33219 3.125 7.5 3.2998 7.5 3.51562V4.29688C7.5 4.5127 7.33219 4.6875 7.125 4.6875H3.375C3.16781 4.6875 3 4.5127 3 4.29688V3.51562ZM3 7.42188V6.64062C3 6.4248 3.16781 6.25 3.375 6.25H7.125C7.33219 6.25 7.5 6.4248 7.5 6.64062V7.42188C7.5 7.6377 7.33219 7.8125 7.125 7.8125H3.375C3.16781 7.8125 3 7.6377 3 7.42188ZM9.75 20.3066V21.4844C9.75 21.7002 9.58219 21.875 9.375 21.875H8.625C8.41781 21.875 8.25 21.7002 8.25 21.4844V20.2983C7.72078 20.27 7.20609 20.0776 6.77953 19.7441C6.59672 19.6011 6.58734 19.3159 6.75281 19.1514L7.30359 18.604C7.43344 18.4751 7.62656 18.4692 7.77844 18.5684C7.95984 18.6865 8.16562 18.75 8.37937 18.75H9.69703C10.0017 18.75 10.2502 18.4609 10.2502 18.106C10.2502 17.8154 10.0809 17.5596 9.83906 17.4844L7.72969 16.8252C6.85828 16.5527 6.24938 15.6816 6.24938 14.7065C6.24938 13.5093 7.14234 12.5366 8.24953 12.5059V11.3281C8.24953 11.1123 8.41734 10.9375 8.62453 10.9375H9.37453C9.58172 10.9375 9.74953 11.1123 9.74953 11.3281V12.5142C10.2788 12.5425 10.7934 12.7344 11.22 13.0684C11.4028 13.2114 11.4122 13.4966 11.2467 13.6611L10.6959 14.2085C10.5661 14.3374 10.373 14.3433 10.2211 14.2441C10.0397 14.1255 9.83391 14.0625 9.62016 14.0625H8.3025C7.99781 14.0625 7.74938 14.3516 7.74938 14.7065C7.74938 14.9971 7.91859 15.2529 8.16047 15.3281L10.2698 15.9873C11.1412 16.2598 11.7502 17.1309 11.7502 18.106C11.7502 19.3037 10.8572 20.2759 9.75 20.3066Z" fill="#3A5DE7"/></svg>`
    }
  },
  mounted() {
    this.fetchPaymentLists()
    console.log(this.value, 'sss')
  },
  computed: {
    filtered() {
      return this.value.filter((v) => {
        const s = this.search.toLowerCase()
        const matches = !s || v.detailShipmentId?.toLowerCase().includes(s)
        const statusOk = !this.status || v.status === this.status
        return matches && statusOk
      })
    },
    totalBilling() {
      // sum of all invoice amounts if available, fallback to 0
      return this.value.reduce((sum, v) => sum + (Number(v.amount) || 0), 0)
    },
    totalPaid() {
      return this.value
        .filter(v => v.status === 'Paid')
        .reduce((sum, v) => sum + (Number(v.amount) || 0), 0)
    },
    totalUnpaid() {
      return this.totalBilling - this.totalPaid
    }
  },
  methods: {
    async fetchPaymentLists() {
      try {
        const params = {}
        if (this.projectId) params.project_contract_id = this.projectId
        if (this.search) params.search = this.search
        if (Array.isArray(this.period) && this.period.length === 2) {
          params.start_date = this.period[0]
          params.end_date = this.period[1]
        }
        if (this.status) params.status = this.status

        const res = await hmacClient.get('/busdev/payment-lists', { params })
        console.log(res?.rows, 'ROWS 222')
        // Expecting { data: [...] } or array directly
        const items = res?.rows;
        this.$emit('input', items)
      } catch (e) {
        // Simple fallback: keep current list
        // Optionally notify
        // console.error('Failed to load payment lists', e)
      }
    },
    onSelect(rows) { this.selected = rows },
    openAdd() {
      // open sidebar in ADD mode
      this.sidebarAction = 'ADD'
      this.sidebarPaymentId = null
      this.showSidebar = true
    },
    edit(i) {
      // open sidebar in EDIT mode; if items are persisted, pass id
      this.editIndex = i
      this.sidebarAction = 'EDIT'
      this.sidebarPaymentId = this.value[i]?.id || null
      this.showSidebar = true
    },
    remove(i) { const arr = this.value.slice(); arr.splice(i,1); this.$emit('input', arr) },
    closeSidebar() { this.showSidebar = false; this.sidebarPaymentId = null; this.editIndex = null },
    onSidebarSaved() {
      // Expect SlidePaymentList to emit normalized payment data
      // const arr = this.value.slice()
      // if (this.editIndex == null) arr.push(payload)
      // else arr.splice(this.editIndex, 1, payload)
      // this.$emit('input', arr)
      this.closeSidebar()
      this.fetchPaymentLists()
    },
    formatCurrency(n) {
      try {
        const val = Number(n || 0)
        return val.toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      } catch(e) { return '0,00' }
    }
  },
  components: { SlidePaymentList, CustomSidebar }
}
</script>
